module.exports = __webpack_public_path__ + "static/media/btn-wechat.cf06fb7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn-wechat.svg
// module id = 177
// module chunks = 0